import React from "react";
import { observer } from "mobx-react";
import { Typography, Box, Fade } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { useCurrentChatStore } from "../Stores/useCurrentChat";

export const EndMessage = observer(() => {
    const store = useCurrentChatStore();
    
    if (!store?.currentEndMessage) return null;
    
    const getIcon = () => {
        switch (store.currentEndMessage?.icon) {
            case "Hourglass":
                return <HourglassEmptyIcon sx={{ fontSize: 16, mr: 1 }} />;
            case "Default":
            default:
                return <InfoOutlinedIcon sx={{ fontSize: 16, mr: 1 }} />;
        }
    };
    
    return (
        <Fade in={true} timeout={300}>
            <Box 
                sx={{ 
                    px: 2, 
                    pb: 1,
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {getIcon()}
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontStyle: 'italic',
                        color: 'text.secondary',
                        fontSize: "13px",
                    }}
                >
                    {store.currentEndMessage.message}
                </Typography>
            </Box>
        </Fade>
    );
});